import React, {useContext, useEffect, useState} from "react";
import {AccountContext} from "../context/AccountProvider";
import Cookies from "universal-cookie";
import {t} from "i18next";
import {Transition} from "@headlessui/react";
import {ChevronDownIcon} from "@radix-ui/react-icons";
import {generateOtp, matchOtp} from "../service/userOtpApi";
import {toast} from "react-toastify";
import {addAccount, getMatchingProfiles, updateAccountById} from "../service/accountApi";
import {translateTextToDevnagri} from "../service/translateApi";
import {familyTreeNames} from "../data/FamilyTreeNames";
import {Modal} from "../components/Modal";
import {countryCodes} from "../data/CountryCode";

export const Register = () => {
    const cookies = new Cookies();
    const pfpBgColors = ["bg-[#0F1F2E]", "bg-[#FF8C42]", "bg-[#FF3C38]", "bg-[#A23E48]"];

    const {setAccount, setCookie} = useContext(AccountContext);

    const [profile, setProfile] = useState({
        email: '',

        firstName: '',
        middleName: '',
        lastName: '',

        firstNameDevanagariScript: '',
        middleNameDevanagariScript: '',
        lastNameDevanagariScript: '',

        dateOfBirth: '',

        familyTreeName: '',
        familyTreeNameDevanagariScript: '',

        gender: 'Male',

        phone: {
            charCode: 'IN',
            dialingCode: '+91',
            countryName: 'India',
            number: ''
        },

        maritalStatus: 'Single',
        sideOfFamily: '',

        imageUrlBg: pfpBgColors[Math.floor(Math.random() * pfpBgColors.length)]
    });

    const [isMemberOfJoglekarKul2010Granth, setIsMemberOfJoglekarKul2010Granth] = useState(false);

    const [filteredFamilyTreeNames, setFilteredFamilyTreeNames] = useState(familyTreeNames);
    const [isFamilyTreeNameDropdownOpen, setIsFamilyTreeNameDropdownOpen] = useState(false);
    const [isSelectingFamilyTreeName, setIsSelectingFamilyTreeName] = useState(false);

    const [isGenderDropdownOpen, setIsGenderDropdownOpen] = useState(false);
    const [isSelectingGender, setIsSelectingGender] = useState(false);

    const maritalStatusOptions = [
        {
            value: "Married",
            label: t("REGISTER_PAGE.MARITAL_STATUS.MARRIED")
        },
        {
            value: "Single",
            label: t("REGISTER_PAGE.MARITAL_STATUS.SINGLE")
        },
        {
            value: "Minor",
            label: t("REGISTER_PAGE.MARITAL_STATUS.MINOR")
        },
        {
            value: profile.gender === "Male" ? "Widower" : "Widowed",
            label: profile.gender === "Male"
                ? t("REGISTER_PAGE.MARITAL_STATUS.WIDOWER")
                : t("REGISTER_PAGE.MARITAL_STATUS.WIDOWED")
        },
        {
            value: "Divorced",
            label: t("REGISTER_PAGE.MARITAL_STATUS.DIVORCED")
        }
    ];

    const [isMaritalStatusDropdownOpen, setIsMaritalStatusDropdownOpen] = useState(false);
    const [isSelectingMaritalStatus, setIsSelectingMaritalStatus] = useState(false);

    const [isJoglekarMaherVashin, setIsJoglekarMaheVashin] = useState(false);

    const [error, setError] = useState({});

    const [emailOtpData, setEmailOtpData] = useState({});
    const [emailOtp, setEmailOtp] = useState("");

    const [isSendEmailOtpButtonDisabled, setIsSendEmailOtpButtonDisabled] = useState(true);
    const [isSendEmailOtpSuccess, setIsSendEmailOtpSuccess] = useState(false);

    const [isVerifyEmailOtpButtonDisabled, setIsVerifyEmailOtpButtonDisabled] = useState(true);
    const [isVerifyEmailOtpSuccess, setIsVerifyEmailOtpSuccess] = useState(false);

    const [isCountryCodeDropdownOpen, setIsCountryCodeDropdownOpen] = useState(false);
    const [isSelectingCountryCode, setIsSelectingCountryCode] = useState(false);

    const [phoneNumberOtpData, setPhoneNumberOtpData] = useState({});
    const [phoneNumberOtp, setPhoneNumberOtp] = useState("");

    const [isSendPhoneNumberOtpButtonDisabled, setIsSendPhoneNumberOtpButtonDisabled] = useState(true);
    const [isSendPhoneNumberOtpSuccess, setIsSendPhoneNumberOtpSuccess] = useState(false);

    const [isVerifyPhoneNumberOtpButtonDisabled, setIsVerifyPhoneNumberOtpButtonDisabled] = useState(true);
    const [isVerifyPhoneNumberOtpSuccess, setIsVerifyPhoneNumberOtpSuccess] = useState(false);

    const [isRegisterButtonDisabled, setIsRegisterButtonDisabled] = useState(true);

    const [showMatchingProfilesModal, setShowMatchingProfilesModal] = useState(false);
    const [matchingProfiles, setMatchingProfiles] = useState([]);

    const translateToDevnagri = (e) => {
        if (e.target.value) {
            translateTextToDevnagri(e.target.value).then((res) => {
                console.log("(CreateProfile.jsx) Translation Response: ", res);
                setProfile({
                    ...profile,
                    [e.target.name + 'DevanagariScript']: res.result
                });
                setError({
                    ...error,
                    [e.target.name + 'DevanagariScript']: ""
                });
            });
        }
    }

    const handleFamilyTreeNameSelect = (familyTreeName) => {
        setIsSelectingFamilyTreeName(false);
        setIsFamilyTreeNameDropdownOpen(false);
        setProfile({
            ...profile,
            familyTreeName: familyTreeName
        });
    }

    const handleGenderSelect = (gender) => {
        setIsSelectingGender(false);
        setIsGenderDropdownOpen(false);
        setProfile({
            ...profile,
            gender: gender
        });
    }

    const maritalStatusLabel = (maritalStatus) => {
        switch (maritalStatus) {
            case 'Single':
                return t("REGISTER_PAGE.MARITAL_STATUS.SINGLE");
            case 'Married':
                return t("REGISTER_PAGE.MARITAL_STATUS.MARRIED");
            case 'Widower':
                return t("REGISTER_PAGE.MARITAL_STATUS.WIDOWER");
            case 'Widowed':
                return t("REGISTER_PAGE.MARITAL_STATUS.WIDOWED");
            case 'Divorced':
                return t("REGISTER_PAGE.MARITAL_STATUS.DIVORCED");
            case 'Minor':
                return t("REGISTER_PAGE.MARITAL_STATUS.MINOR");
            default:
                return t("REGISTER_PAGE.MARITAL_STATUS.SINGLE");
        }
    }

    const handleMaritalStatusSelect = (maritalStatus) => {
        setIsSelectingMaritalStatus(false);
        setIsMaritalStatusDropdownOpen(false);
        setProfile({
            ...profile,
            maritalStatus: maritalStatus
        });
    }

    useEffect(() => {
        console.log("(CreateProfile) (Changed) Gender: ", profile.gender);
        console.log("(CreateProfile) (Changed) Marital Status: ", profile.maritalStatus);
        if (profile.gender === 'Female' && (profile.maritalStatus === 'Single' || profile.maritalStatus === 'Minor')) {
            setProfile({
                ...profile,
                sideOfFamily: 'MaherVashin'
            })
        }
    }, [profile.gender, profile.maritalStatus]);

    const validateEmail = (email) => {
        return /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(email);
    }

    const validateEmailId = (e) => {
        if (e.target.value !== "") {
            if (!validateEmail(e.target.value)) {
                setError({
                    ...error,
                    [e.target.name]: t("REGISTER_PAGE.EMAIL_INPUT.ERROR.INVALID_INPUT")
                });
            } else {
                setIsSendEmailOtpButtonDisabled(false);

                if (Object.keys(error).includes(e.target.name)) {
                    setError({
                        ...error,
                        [e.target.name]: ""
                    });
                }
            }
        } else {
            setIsSendEmailOtpButtonDisabled(true);

            if (Object.keys(error).includes(e.target.name)) {
                setError({
                    ...error,
                    [e.target.name]: ""
                });
            }
        }
    }

    useEffect(() => {
        if (validateEmail(profile.email)) {
            setIsSendEmailOtpButtonDisabled(false);
        } else {
            setIsSendEmailOtpButtonDisabled(true);
        }
    }, [profile.email]);

    const handleCountryCodeSelect = (countryDetails) => {
        setIsSelectingCountryCode(false);
        setIsCountryCodeDropdownOpen(false);
        setProfile({
            ...profile,
            phone: {
                ...profile.phone,
                charCode: countryDetails.countryCode,
                dialingCode: countryDetails.countryDialingCode,
                countryName: countryDetails.countryName
            }
        });
    }

    const isNumberValid = (phone) => {
        let reg = /^\d+$/;
        return reg.test(phone);
    }

    const validatePhoneNumber = (e) => {
        if (e.target.value !== "") {
            if (!isNumberValid(e.target.value) || e.target.value.length < 10) {
                setError({
                    ...error,
                    [e.target.name]: t("REGISTER_PAGE.PHONE_INPUT.ERROR.INVALID_INPUT")
                });
            } else {
                setIsSendEmailOtpButtonDisabled(false);

                if (Object.keys(error).includes(e.target.name)) {
                    setError({
                        ...error,
                        [e.target.name]: ""
                    });
                }
            }
        } else {
            setIsSendEmailOtpButtonDisabled(true);

            if (Object.keys(error).includes(e.target.name)) {
                setError({
                    ...error,
                    [e.target.name]: ""
                });
            }
        }
    }

    useEffect(() => {
        if (!isNumberValid(profile.phone.number) || profile.phone.number.length < 10) {
            setIsSendPhoneNumberOtpButtonDisabled(true);
        } else {
            setIsSendPhoneNumberOtpButtonDisabled(false);
        }
    }, [profile.phone]);

    const handleFormData = (e) => {
        console.log(e.target.name + ': ' + e.target.value);

        setProfile({
            ...profile,
            [e.target.name]: e.target.value
        });

        if (Object.keys(error).includes(e.target.name) || e.target.value === "") {
            setError({
                ...error,
                [e.target.name]: ""
            });
        }
    }

    const sendOtpOnEmailButtonClick = () => {
        setIsSendEmailOtpButtonDisabled(true);
        generateOtp(profile.email, "email", "register")
            .then((result) => {
                console.log("(Register.jsx) Send OTP Result: ", result);
                setEmailOtpData(result.data);
                setIsSendEmailOtpSuccess(true);
                if (Object.keys(error).includes("email")) {
                    setError({
                        ...error,
                        "email": ""
                    });
                }
                toast.dismiss();
                toast.success(result.message, {
                    autoClose: 60000,
                    closeOnClick: false
                });
            })
            .catch((error) => {
                console.log("(Register.jsx) Error while sending OTP: ", error);
                toast.dismiss();
                toast.error(error.data.message);
            })
            .finally(() => {
                setIsSendEmailOtpButtonDisabled(false);
            });
    }

    useEffect(() => {
        if (emailOtp.length === 6 && emailOtp) {
            setIsVerifyEmailOtpButtonDisabled(false);
        } else {
            setIsVerifyEmailOtpButtonDisabled(true);
        }
    }, [emailOtp]);

    const verifyEmailOtpButtonClick = () => {
        setIsVerifyEmailOtpButtonDisabled(true);
        if (emailOtpData && emailOtpData.userId && emailOtp) {
            matchOtp(emailOtpData.userId, emailOtp, "register")
                .then((result) => {
                    console.log("(Register.jsx) Match OTP Result: ", result);
                    if (result.success) {
                        setIsVerifyEmailOtpSuccess(true);
                        toast.dismiss();
                        toast.success(result.message);
                    }
                })
                .catch((error) => {
                    console.log("(Register.jsx) Error while matching OTP: ", error);
                    toast.dismiss();
                    toast.error(error.data.message);
                })
                .finally(() => {
                    setIsVerifyEmailOtpButtonDisabled(false);
                });
        }
    }

    const sendOtpOnPhoneNumberButtonClick = () => {
        setIsSendPhoneNumberOtpButtonDisabled(true);
        generateOtp(profile.phone, "phone", "register")
            .then((result) => {
                console.log("(Register.jsx) Phone Number Send OTP Result: ", result);
                setPhoneNumberOtpData(result.data);
                setIsSendPhoneNumberOtpSuccess(true);
                if (Object.keys(error).includes("phoneNumber")) {
                    setError({
                        ...error,
                        "phoneNumber": ""
                    });
                }
                toast.dismiss();
                toast.success(result.message, {
                    autoClose: 60000,
                    closeOnClick: false
                });
            })
            .catch((error) => {
                console.log("(Register.jsx) Error while sending Phone Number OTP: ", error);
                toast.dismiss();
                toast.error(error.data.message);
            })
            .finally(() => {
                setIsSendPhoneNumberOtpButtonDisabled(false);
            });
    }

    useEffect(() => {
        if (phoneNumberOtp.length === 6 && phoneNumberOtp) {
            setIsVerifyPhoneNumberOtpButtonDisabled(false);
        } else {
            setIsVerifyPhoneNumberOtpButtonDisabled(true);
        }
    }, [phoneNumberOtp]);

    const verifyPhoneNumberOtpButtonClick = () => {
        setIsVerifyPhoneNumberOtpButtonDisabled(true);
        if (phoneNumberOtpData && phoneNumberOtpData.userId && phoneNumberOtp) {
            matchOtp(phoneNumberOtpData.userId, phoneNumberOtp, "register")
                .then((result) => {
                    console.log("(Register.jsx) Phone Number Match OTP Result: ", result);
                    if (result.success) {
                        setIsVerifyPhoneNumberOtpSuccess(true);
                        toast.dismiss();
                        toast.success(result.message);
                    }
                })
                .catch((error) => {
                    console.log("(Register.jsx) Error while matching Phone Number OTP: ", error);
                    toast.dismiss();
                    toast.error(error.data.message);
                })
                .finally(() => {
                    setIsVerifyPhoneNumberOtpButtonDisabled(false);
                });
        }
    }

    useEffect(() => {
        if (isVerifyEmailOtpSuccess && isVerifyPhoneNumberOtpSuccess) {
            setIsRegisterButtonDisabled(false);
        } else {
            setIsRegisterButtonDisabled(true);
        }
    }, [isVerifyEmailOtpSuccess, isVerifyPhoneNumberOtpSuccess]);

    useEffect(() => {
        if (
            profile.firstName !== '' && profile.middleName !== '' && profile.lastName !== '' &&
            isVerifyEmailOtpSuccess && isVerifyPhoneNumberOtpSuccess
        ) {
            if (isMemberOfJoglekarKul2010Granth && (profile.dateOfBirth === '' || profile.familyTreeName === '')) {
                setIsRegisterButtonDisabled(true);
            } else if (!isMemberOfJoglekarKul2010Granth) {
                setIsRegisterButtonDisabled(false);
            }
        } else {
            setIsRegisterButtonDisabled(true);
        }
    }, [profile.firstName, profile.middleName, profile.lastName,
        isMemberOfJoglekarKul2010Granth, profile.dateOfBirth, profile.familyTreeName,
        isVerifyEmailOtpSuccess, isVerifyPhoneNumberOtpSuccess
    ]);

    const validate = () => {
        let tempError = {...error}

        if (profile.firstName === '') {
            tempError['firstName'] = t("REGISTER_PAGE.NAME.ERROR.FIRST_NAME");
        }

        if (profile.middleName === '') {
            tempError['middleName'] = t("REGISTER_PAGE.NAME.ERROR.MIDDLE_NAME");
        }

        if (profile.lastName === '') {
            tempError['lastName'] = t("REGISTER_PAGE.NAME.ERROR.LAST_NAME");
        }

        if (isMemberOfJoglekarKul2010Granth) {
            if (profile.dateOfBirth === '') {
                tempError['dateOfBirth'] = t("REGISTER_PAGE.DOB.ERROR");
            }

            if (profile.familyTreeName === '') {
                tempError['familyTreeName'] = t("REGISTER_PAGE.FAMILY_TREE_NAME.ERROR");
            }
        }

        return tempError;
    }

    const addNewAccount = () => {
        setIsRegisterButtonDisabled(true);

        const trimmedProfile = {
            ...profile,
            email: profile.email.trim(),

            firstName: profile.firstName.trim(),
            middleName: profile.middleName.trim(),
            lastName: profile.lastName.trim(),

            firstNameDevanagariScript: profile.firstNameDevanagariScript.trim(),
            middleNameDevanagariScript: profile.middleNameDevanagariScript.trim(),
            lastNameDevanagariScript: profile.lastNameDevanagariScript.trim(),

            dateOfBirth: profile.dateOfBirth.trim(),

            familyTreeName: profile.familyTreeName.trim(),
            familyTreeNameDevanagariScript: profile.familyTreeNameDevanagariScript.trim(),

            phone: {
                ...profile.phone,
                number: profile.phone.number.trim()
            },

            sideOfFamily: profile.sideOfFamily.trim()
        };


        const accountData = {
            ...trimmedProfile,
            imageUrl: trimmedProfile.firstName[0] + trimmedProfile.middleName[0],
            sideOfFamily: isJoglekarMaherVashin ? 'MaherVashin' : '',
            outsider: trimmedProfile.lastName.toLowerCase() !== 'joglekar' && !isJoglekarMaherVashin
        }

        console.log("(Register.jsx) New Account to be Added: ", accountData);

        if (isMemberOfJoglekarKul2010Granth) {
            getMatchingProfiles(accountData)
                .then((response) => {
                    console.log("(Register.jsx) Get Matching Profiles Data: ", response);
                    if (response.success) {
                        setMatchingProfiles(response.data);
                        if (response.data.length === 1) {
                            console.log("Matching Profile Data: ", response.data);

                            updateAccountById(response.data[0]._id, accountData)
                                .then((response) => {
                                    console.log("(Register.jsx) Update Existing Matching Account By Id Response: ", response);

                                    if (response?.success) {
                                        toast.dismiss();
                                        cookies.set('email', response.data.email);
                                        setCookie(cookies.get('email'));
                                        setAccount(response.data);
                                    }
                                })
                                .catch((error) => {
                                    console.log("(Register.jsx) Update Existing Matching Account By Id Error: ", error);
                                });
                        } else {
                            setShowMatchingProfilesModal(true);
                        }
                        setIsRegisterButtonDisabled(false);
                    }
                })
                .catch((error) => {
                    console.log("(Register.jsx) Error while getting Matching Profiles Data: ", error);
                    setIsRegisterButtonDisabled(false);
                });
        } else {
            addAccount(accountData)
                .then((response) => {
                    console.log("(Register.jsx) Account Added: ", response);
                    if (response.success) {
                        console.log("(Register.jsx) Account Added Email: ", response.data.email);
                        toast.dismiss();
                        cookies.set('email', response.data.email);
                        setAccount(prevState => ({
                            ...prevState,
                            ...response.data
                        }));
                        setCookie(cookies.get('email'));
                        setIsRegisterButtonDisabled(false);
                    }
                })
                .catch((error) => {
                    console.log("(Register.jsx) Error While Adding New Account: ", error);
                    toast.dismiss();
                    toast.error(error.data.message);
                    setIsRegisterButtonDisabled(false);
                });
        }
    }

    useEffect(() => {
        console.log("Updated Profile --> ", profile);
    }, [profile]);

    return (
        <>
            {/* Register Page */}
            <div className="h-[100vh] w-full flex flex-row items-center justify-center">
                {/* Background */}
                <div className="absolute inset-0">
                    <img
                        src="/assets/home-page-hero-section-bg.png"
                        alt=""
                        className="absolute w-full h-full object-bottom object-cover shadow-lg"
                    />
                    <div
                        className="absolute h-full w-full flex
                            items-end portrait:justify-center landscape:px-[4rem]"
                    >
                        <img
                            src="/assets/hero-section-home-page-banner-statue.png"
                            alt=""
                            className="portrait:h-[20%] portrait:xs:h-[22.5%]
                                    portrait:md:h-[27.5%] portrait:jk:h-[37.5%] portrait:lg:h-[50%]
                                    landscape:h-[50%] landscape:jk:h-[60%] landscape:lg:h-[70%]
                                    aspect-auto object-contain"
                        />
                        <img
                            src="/assets/hero-section-home-page-title.svg"
                            alt=""
                            className="portrait:h-[13%] portrait:xs:h-[15%]
                                    portrait:md:h-[20%] portrait:jk:h-[27.5%] portrait:lg:h-[37.5%]
                                    landscape:h-[35%] landscape:jk:h-[42.5%] landscape:lg:h-[50%]
                                    aspect-auto object-contain
                                    portrait:mb-[2rem] landscape:mb-[2rem]"
                        />
                    </div>
                </div>

                {/* Register Card */}
                <div
                    className="z-10 h-full w-full flex flex-1
                        flex-col items-center justify-start landscape:items-end
                        portrait:p-[2rem] portrait:jk:p-[3.5rem] portrait:lg:p-[5rem]
                        landscape:p-[1.5rem] landscape:jk:p-[1.75rem] landscape:lg:p-[2rem]"
                >
                    <div
                        className="flex flex-col bg-white max-h-full
                            portrait:max-h-[70vh]
                            portrait:w-full portrait:sm:w-[27.5rem] portrait:jk:w-[35rem] portrait:lg:w-[40rem]

                            portrait:rounded-xl landscape:rounded-xl

                            landscape:w-[18.75rem] landscape:xs:w-[21.5rem] landscape:md:w-[22.5rem]
                            landscape:jk:w-[27.5rem] landscape:lg:w-[30rem]
                            shadow-[0_13px_27px_-5px_#32325d40,_0_8px_16px_-8px_#0000004d]"
                    >
                        {/* Header */}
                        <div
                            className="flex flex-col gap-y-[0.35rem]
                                portrait:px-[1.25rem] portrait:pt-[0.95rem]
                                portrait:jk:px-[1.5rem] portrait:jk:pt-[1.1rem]
                                portrait:lg:px-[2rem] portrait:lg:pt-[1.5rem]

                                landscape:px-[1.25rem] landscape:pt-[0.95rem]
                                landscape:jk:px-[1.5rem] landscape:jk:pt-[1.1rem]
                                landscape:lg:px-[1.75rem] landscape:lg:pt-[1.5rem]"
                        >
                            <h1
                                className="leading-tight
                                    portrait:text-[1.5rem] portrait:sm:text-[1.65rem]
                                    portrait:jk:text-[2rem] portrait:lg:text-[2.75rem]
                                    landscape:text-[1.25rem] landscape:md:text-[1.45rem]
                                    landscape:jk:text-[1.45rem] landscape:lg:text-[1.75rem]
                                    font-custom-bold text-gray-900"
                            >
                                {t("REGISTER_PAGE.GREETING.MAIN")}
                            </h1>

                            <p
                                className="leading-tight
                                    portrait:text-[1.15rem] portrait:sm:text-[1.25rem]
                                    portrait:jk:text-[1.5rem] portrait:lg:text-[2rem]
                                    landscape:text-[0.85rem] landscape:jk:text-[1rem] landscape:lg:text-[1.225rem]
                                    font-custom-semi-bold text-gray-500"
                            >
                                {t("REGISTER_PAGE.GREETING.SUB")}
                            </p>
                        </div>

                        {/* Form - Body */}
                        <div
                            className="flex flex-col items-center overflow-y-scroll thin-scrollbar
                                portrait:gap-[0.85rem] portrait:md:gap-[1rem]
                                portrait:jk:gap-[1.25rem] portrait:lg:gap-[1.75rem]

                                landscape:gap-[0.6rem] landscape:md:gap-[0.75rem]
                                landscape:jk:gap-[1rem] landscape:lg:gap-[1.25rem]

                                portrait:px-[1.25rem] portrait:py-[0.75rem]
                                portrait:jk:px-[1.5rem] portrait:jk:py-[1rem]
                                portrait:lg:px-[2rem] portrait:lg:py-[1.5rem]

                                landscape:px-[1.25rem] landscape:py-[0.4rem]
                                landscape:jk:px-[1.5rem] landscape:jk:py-[0.55rem]
                                landscape:lg:px-[1.75rem] landscape:lg:py-[1rem]"
                        >
                            {/* Full Name */}
                            <fieldset className={"w-full"}>
                                <div
                                    className="!flex-1 !w-full custom-input-container"
                                >
                                    {/* Label */}
                                    <label htmlFor="firstName">
                                        {t("REGISTER_PAGE.NAME.LABEL")}
                                    </label>

                                    {/* Input Fields */}
                                    <div className="custom-input-multiple-fields-container">
                                        {/* First Name */}
                                        <div className="flex-1 flex flex-col gap-1">
                                            <input
                                                id="firstName"
                                                className={"custom-input w-full"}
                                                name='firstName'
                                                placeholder={t("REGISTER_PAGE.NAME.PLACEHOLDER.FIRST_NAME")}
                                                value={profile.firstName}
                                                onChange={handleFormData}
                                                onFocus={() => {
                                                    setError({
                                                        ...error,
                                                        firstName: "",
                                                        middleName: "",
                                                        lastName: ""
                                                    })
                                                }}
                                                onBlur={translateToDevnagri}
                                            />

                                            {
                                                error['firstName'] && (
                                                    <p
                                                        className="custom-input-error-message portrait:sm:hidden landscape:hidden"
                                                        id="error"
                                                    >
                                                        {error['firstName']}
                                                    </p>
                                                )
                                            }
                                        </div>

                                        {/* Middle Name */}
                                        <div className="flex-1 flex flex-col gap-1">
                                            <input
                                                id="middleName"
                                                className={"custom-input w-full"}
                                                name='middleName'
                                                placeholder={t("REGISTER_PAGE.NAME.PLACEHOLDER.MIDDLE_NAME")}
                                                value={profile.middleName}
                                                onChange={handleFormData}
                                                onFocus={() => {
                                                    setError({
                                                        ...error,
                                                        firstName: "",
                                                        middleName: "",
                                                        lastName: ""
                                                    })
                                                }}
                                                onBlur={translateToDevnagri}
                                            />

                                            {
                                                error['middleName'] && (
                                                    <p
                                                        className="custom-input-error-message portrait:sm:hidden landscape:hidden"
                                                        id="error"
                                                    >
                                                        {error['middleName']}
                                                    </p>
                                                )
                                            }
                                        </div>

                                        {/* Last Name */}
                                        <div className="flex-1 flex flex-col gap-1">
                                            <input
                                                className={"custom-input w-full"}
                                                id="lastName"
                                                name='lastName'
                                                placeholder={t("REGISTER_PAGE.NAME.PLACEHOLDER.LAST_NAME")}
                                                value={profile.lastName}
                                                onChange={handleFormData}
                                                onFocus={() => {
                                                    setError({
                                                        ...error,
                                                        firstName: "",
                                                        middleName: "",
                                                        lastName: ""
                                                    })
                                                }}
                                                onBlur={translateToDevnagri}
                                            />

                                            {
                                                error['lastName'] && (
                                                    <p
                                                        className="custom-input-error-message portrait:sm:hidden landscape:hidden"
                                                        id="error"
                                                    >
                                                        {error['lastName']}
                                                    </p>
                                                )
                                            }
                                        </div>
                                    </div>

                                    {/* Error Container */}
                                    {
                                        (error['firstName'] !== '' || error['middleName'] !== '' || error['lastName'] !== '') && (
                                            <div
                                                className="custom-input-multiple-fields-container portrait:hidden"
                                            >
                                                <p
                                                    className="flex-1 text-red-600 font-custom-regular
                                                        portrait:text-[0.625rem] portrait:md:text-[0.9rem]
                                                        portrait:jk:text-[1.2rem] portrait:lg:text-[1.45rem]
                                                        landscape:text-[0.45rem] landscape:md:text-[0.5rem]
                                                        landscape:jk:text-[0.6rem] landscape:lg:text-[0.7rem]"
                                                    id="error"
                                                >
                                                    {error['firstName'] ? error['firstName'] : ''}
                                                </p>

                                                <p
                                                    className="flex-1 text-red-600 font-custom-regular
                                                        portrait:text-[0.625rem] portrait:md:text-[0.9rem]
                                                        portrait:jk:text-[1.2rem] portrait:lg:text-[1.45rem]
                                                        landscape:text-[0.45rem] landscape:md:text-[0.5rem]
                                                        landscape:jk:text-[0.6rem] landscape:lg:text-[0.7rem]"
                                                    id="error"
                                                >
                                                    {error['middleName'] ? error['middleName'] : ''}
                                                </p>

                                                <p
                                                    className="flex-1 text-red-600 font-custom-regular
                                                        portrait:text-[0.625rem] portrait:md:text-[0.9rem]
                                                        portrait:jk:text-[1.2rem] portrait:lg:text-[1.45rem]
                                                        landscape:text-[0.45rem] landscape:md:text-[0.5rem]
                                                        landscape:jk:text-[0.6rem] landscape:lg:text-[0.7rem]"
                                                    id="error"
                                                >
                                                    {error['lastName'] ? error['lastName'] : ''}
                                                </p>
                                            </div>
                                        )
                                    }

                                    {/* Is Member of Joglekarkul 2010 Granth */}
                                    {
                                        (profile.lastName.toLowerCase() === 'joglekar' || isJoglekarMaherVashin) && (
                                            <label
                                                className="custom-input-label-checkbox"
                                            >
                                                <input
                                                    type="checkbox"
                                                    name='isJoglekarMaherVashin'
                                                    checked={isMemberOfJoglekarKul2010Granth}
                                                    onChange={() => setIsMemberOfJoglekarKul2010Granth(!isMemberOfJoglekarKul2010Granth)}
                                                />
                                                <p>
                                                    {t("REGISTER_PAGE.IS_MEMBER_OF_JOGLEKARKUL_2010_GRANTH")}
                                                </p>
                                            </label>
                                        )
                                    }
                                </div>
                            </fieldset>

                            {/* Date of Birth | Family Tree Name */}
                            {
                                isMemberOfJoglekarKul2010Granth && (
                                    <fieldset className={"w-full flex-1"}>
                                        <div className="custom-input-multiple-fields-container">
                                            {/* Date of Birth */}
                                            <div className="custom-input-container">
                                                <label>
                                                    {t("REGISTER_PAGE.DOB.LABEL")}
                                                </label>
                                                <div className="flex flex-col relative w-full">
                                                    <input
                                                        type="date"
                                                        name='dateOfBirth'
                                                        required
                                                        value={profile.dateOfBirth}
                                                        onChange={handleFormData}
                                                        className="custom-input"
                                                    />
                                                    {
                                                        error['dateOfBirth'] &&
                                                        <p
                                                            className="custom-input-error-message"
                                                            id="error"
                                                        >
                                                            {error['dateOfBirth']}
                                                        </p>
                                                    }
                                                </div>
                                            </div>

                                            {/* Family Tree Name */}
                                            <div
                                                className="custom-input-container"
                                            >
                                                <label>
                                                    {t("REGISTER_PAGE.FAMILY_TREE_NAME.LABEL")}
                                                </label>

                                                <div className="h-full w-full flex flex-col">
                                                    <div
                                                        className={`custom-input-dropdown-button
                                                        ${isFamilyTreeNameDropdownOpen && 'ring-4 ring-offset-1 ring-[#5F0F40]'}`}
                                                    >
                                                        <input
                                                            id="familyTreeName"
                                                            name="familyTreeName"
                                                            value={profile.familyTreeName}
                                                            onBlur={(e) => {
                                                                console.log("Family Tree Name Input Blur: ", isSelectingFamilyTreeName);
                                                                if (!isSelectingFamilyTreeName) {
                                                                    setIsFamilyTreeNameDropdownOpen(false);
                                                                }
                                                                translateToDevnagri(e);
                                                            }}
                                                            onClick={() => setIsFamilyTreeNameDropdownOpen(true)}
                                                            onKeyUp={(e) => {
                                                                if (e.key === "Escape") {
                                                                    setIsFamilyTreeNameDropdownOpen(false);
                                                                }
                                                            }}
                                                            onFocus={(e) => {
                                                                if (e.target.value === "") {
                                                                    setFilteredFamilyTreeNames(familyTreeNames);
                                                                } else {
                                                                    console.log("Family Tree Name Input Value: ", e.target.value);
                                                                    setFilteredFamilyTreeNames(
                                                                        familyTreeNames
                                                                            .filter((familyTreeName) => {
                                                                                return familyTreeName.toLowerCase().includes(e.target.value.toLowerCase());
                                                                            })
                                                                    );
                                                                }
                                                            }}
                                                            onChange={(e) => {
                                                                if (e.target.value === "") {
                                                                    setFilteredFamilyTreeNames(familyTreeNames);
                                                                } else {
                                                                    console.log("Family Tree Name Input Value: ", e.target.value);
                                                                    setFilteredFamilyTreeNames(
                                                                        familyTreeNames
                                                                            .filter((familyTreeName) => {
                                                                                return familyTreeName.toLowerCase().includes(e.target.value.toLowerCase());
                                                                            })
                                                                    );
                                                                }

                                                                setProfile({
                                                                    ...profile,
                                                                    familyTreeName: e.target.value
                                                                });

                                                                setError({
                                                                    ...error,
                                                                    [e.target.name]: ""
                                                                });
                                                            }}
                                                        />

                                                        <ChevronDownIcon
                                                            className={`${isFamilyTreeNameDropdownOpen ? 'rotate-180' : 'rotate-0'} `}
                                                            aria-hidden="true"
                                                            stroke="#292D32"
                                                            strokeWidth={"0.1vh"}
                                                            onClick={() => setIsFamilyTreeNameDropdownOpen(!isFamilyTreeNameDropdownOpen)}
                                                        />
                                                    </div>

                                                    {/* Family Tree Name Dropdown */}
                                                    <div className={"relative"}>
                                                        <Transition show={isFamilyTreeNameDropdownOpen}>
                                                            <div
                                                                className={`bg-white absolute left-0 right-0 z-[100] max-h-[7.5rem]
                                                                    origin-top-right rounded-md shadow-2xl 
                                                                    border border-gray-700 overflow-y-scroll overflow-x-hidden
                                                                    data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 
                                                                    data-[enter]:duration-100 data-[enter]:ease-out 
                                                                    data-[leave]:duration-75 data-[leave]:ease-in`}
                                                            >
                                                                {
                                                                    filteredFamilyTreeNames.length > 0
                                                                        ? filteredFamilyTreeNames.map((familyTreeName, index) => (
                                                                            <button
                                                                                key={index}
                                                                                className={`custom-input-dropdown-list-button`}
                                                                                onMouseDown={() => setIsSelectingFamilyTreeName(true)}
                                                                                onClick={() => handleFamilyTreeNameSelect(familyTreeName)}
                                                                            >
                                                                                <p className={`text-nowrap overflow-x-scroll no-scrollbar`}>
                                                                                    {familyTreeName}
                                                                                </p>
                                                                            </button>
                                                                        )) : (
                                                                            <button
                                                                                className={`custom-input-dropdown-list-button`}
                                                                                onClick={() => setIsFamilyTreeNameDropdownOpen(false)}
                                                                            >
                                                                                <p className={`text-nowrap overflow-x-scroll no-scrollbar`}>
                                                                                    {profile.familyTreeName}
                                                                                </p>
                                                                            </button>
                                                                        )
                                                                }
                                                            </div>
                                                        </Transition>
                                                    </div>
                                                </div>

                                                {
                                                    error['familyTreeName'] && (
                                                        <span
                                                            className="custom-input-error-message"
                                                            id="error"
                                                        >
                                                            {error['familyTreeName']}
                                                        </span>
                                                    )
                                                }
                                            </div>
                                        </div>
                                    </fieldset>
                                )
                            }

                            {/* Gender | Marital Status */}
                            <div className="custom-input-multiple-fields-container w-full">
                                {/* Gender */}
                                <div className="custom-input-container">
                                    {/* Gender Label */}
                                    <label htmlFor="gender">
                                        {t("REGISTER_PAGE.GENDER.LABEL")}
                                    </label>

                                    {/* Gender Button | Dropdown */}
                                    <div className="h-full w-full flex flex-col">
                                        <button
                                            onBlur={() => {
                                                if (!isSelectingGender) {
                                                    setIsGenderDropdownOpen(false);
                                                }
                                            }}
                                            className={`custom-input-dropdown-button
                                            ${isGenderDropdownOpen ? 'focus:ring-4 focus:ring-offset-1 focus:ring-[#5F0F40]' : ''}`}
                                            onClick={() => setIsGenderDropdownOpen(!isGenderDropdownOpen)}
                                        >
                                            <div>
                                                <p>
                                                    {
                                                        profile.gender === "Male"
                                                            ? t("REGISTER_PAGE.GENDER.MALE")
                                                            : t("REGISTER_PAGE.GENDER.FEMALE")
                                                    }
                                                </p>
                                                <img
                                                    src={profile.gender === "Male" ? "assets/male-gender-icon.png" : "assets/female-gender-icon.png"}
                                                    alt={profile.gender === "Male" ? "Male" : "Female"}
                                                />
                                            </div>
                                            <ChevronDownIcon
                                                className={`${isGenderDropdownOpen ? 'rotate-180' : 'rotate-0'} `}
                                                aria-hidden="true"
                                                stroke="#292D32"
                                                strokeWidth={"0.1vh"}
                                            />
                                        </button>

                                        {/* Gender Dropdown */}
                                        <div className={"relative mt-[0.5vh]"}>
                                            <Transition show={isGenderDropdownOpen}>
                                                <div
                                                    className={`bg-white absolute left-0 right-0 z-[100] max-h-[15vh]
                                                        origin-top-right rounded-md shadow-2xl 
                                                        border border-gray-700 overflow-y-scroll
                                                        data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 
                                                        data-[enter]:duration-100 data-[enter]:ease-out 
                                                        data-[leave]:duration-75 data-[leave]:ease-in`}
                                                >
                                                    <button
                                                        className="custom-input-dropdown-list-button"
                                                        onClick={() => handleGenderSelect("Male")}
                                                        onMouseDown={() => setIsSelectingGender(true)}
                                                    >
                                                        <p>
                                                            {t("REGISTER_PAGE.GENDER.MALE")}
                                                        </p>
                                                        <img
                                                            src={"assets/male-gender-icon.png"}
                                                            alt={"Male"}
                                                        />
                                                    </button>
                                                    <button
                                                        className="custom-input-dropdown-list-button"
                                                        onClick={() => handleGenderSelect("Female")}
                                                        onMouseDown={() => setIsSelectingGender(true)}
                                                    >
                                                        <p>
                                                            {t("REGISTER_PAGE.GENDER.FEMALE")}
                                                        </p>
                                                        <img
                                                            src={"assets/female-gender-icon.png"}
                                                            alt={"Female"}
                                                        />
                                                    </button>
                                                </div>
                                            </Transition>
                                        </div>
                                    </div>
                                </div>

                                {/* Marital Status */}
                                <div className="custom-input-container">
                                    {/* Marital Status Label */}
                                    <label htmlFor="maritalStatus">
                                        <img
                                            src={"assets/marriage-icon.png"}
                                            alt={"Marriage"}
                                            title={"Marriage"}
                                        />
                                        {t("REGISTER_PAGE.MARITAL_STATUS.LABEL")}
                                    </label>

                                    {/* Marital Status Button | Dropdown */}
                                    <div className="h-full w-full flex flex-col">
                                        <button
                                            onBlur={() => {
                                                if (!isSelectingMaritalStatus) {
                                                    setIsMaritalStatusDropdownOpen(false);
                                                }
                                            }}
                                            className={`custom-input-dropdown-button
                                                ${isMaritalStatusDropdownOpen && 'focus:ring-4 focus:ring-offset-1 focus:ring-[#5F0F40]'}`}
                                            onClick={() => setIsMaritalStatusDropdownOpen(!isMaritalStatusDropdownOpen)}
                                        >
                                            <p>
                                                {maritalStatusLabel(profile.maritalStatus)}
                                            </p>
                                            <ChevronDownIcon
                                                className={`${isMaritalStatusDropdownOpen ? 'rotate-180' : 'rotate-0'} `}
                                                aria-hidden="true"
                                                stroke="#292D32"
                                                strokeWidth={"0.1vh"}
                                            />
                                        </button>

                                        {/* Marital Status Dropdown */}
                                        <div className={"relative mt-[0.5vh]"}>
                                            <Transition show={isMaritalStatusDropdownOpen}>
                                                <div
                                                    className={`bg-white absolute left-0 right-0 z-[100] 
                                                        max-h-[5rem] origin-top-right rounded-md shadow-2xl 
                                                        border border-gray-700 overflow-y-scroll
                                                        data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 
                                                        data-[enter]:duration-100 data-[enter]:ease-out 
                                                        data-[leave]:duration-75 data-[leave]:ease-in`}
                                                >
                                                    {
                                                        maritalStatusOptions.map((option, index) => (
                                                            <button
                                                                className="custom-input-dropdown-list-button"
                                                                onClick={() => handleMaritalStatusSelect(option.value)}
                                                                onMouseDown={() => setIsSelectingMaritalStatus(true)}
                                                            >
                                                                <p>
                                                                    {option.label}
                                                                </p>
                                                            </button>
                                                        ))
                                                    }
                                                    {/*<button*/}
                                                    {/*    className="custom-input-dropdown-list-button"*/}
                                                    {/*    onClick={() => handleMaritalStatusSelect("Minor")}*/}
                                                    {/*    onMouseDown={() => setIsSelectingMaritalStatus(true)}*/}
                                                    {/*>*/}
                                                    {/*    <p>*/}
                                                    {/*        {t("REGISTER_PAGE.MARITAL_STATUS.MINOR")}*/}
                                                    {/*    </p>*/}
                                                    {/*</button>*/}
                                                    {/*<button*/}
                                                    {/*    className="custom-input-dropdown-list-button"*/}
                                                    {/*    onClick={() => handleMaritalStatusSelect("Single")}*/}
                                                    {/*    onMouseDown={() => setIsSelectingMaritalStatus(true)}*/}
                                                    {/*>*/}
                                                    {/*    <p>*/}
                                                    {/*        {t("REGISTER_PAGE.MARITAL_STATUS.SINGLE")}*/}
                                                    {/*    </p>*/}
                                                    {/*</button>*/}
                                                    {/*<button*/}
                                                    {/*    className="custom-input-dropdown-list-button"*/}
                                                    {/*    onClick={() => handleMaritalStatusSelect("Married")}*/}
                                                    {/*    onMouseDown={() => setIsSelectingMaritalStatus(true)}*/}
                                                    {/*>*/}
                                                    {/*    <p>*/}
                                                    {/*        {t("REGISTER_PAGE.MARITAL_STATUS.MARRIED")}*/}
                                                    {/*    </p>*/}
                                                    {/*</button>*/}
                                                    {/*<button*/}
                                                    {/*    className="custom-input-dropdown-list-button"*/}
                                                    {/*    onClick={() => profile.gender === "Male"*/}
                                                    {/*        ? handleMaritalStatusSelect("Widower")*/}
                                                    {/*        : handleMaritalStatusSelect("Widowed")}*/}
                                                    {/*    onMouseDown={() => setIsSelectingMaritalStatus(true)}*/}
                                                    {/*>*/}
                                                    {/*    <p>*/}
                                                    {/*        {*/}
                                                    {/*            profile.gender === "Male"*/}
                                                    {/*                ? t("REGISTER_PAGE.MARITAL_STATUS.WIDOWER")*/}
                                                    {/*                : t("REGISTER_PAGE.MARITAL_STATUS.WIDOWED")*/}
                                                    {/*        }*/}
                                                    {/*    </p>*/}
                                                    {/*</button>*/}
                                                    {/*<button*/}
                                                    {/*    className="custom-input-dropdown-list-button"*/}
                                                    {/*    onClick={() => handleMaritalStatusSelect("Divorced")}*/}
                                                    {/*    onMouseDown={() => setIsSelectingMaritalStatus(true)}*/}
                                                    {/*>*/}
                                                    {/*    <p>*/}
                                                    {/*        {t("REGISTER_PAGE.MARITAL_STATUS.DIVORCED")}*/}
                                                    {/*    </p>*/}
                                                    {/*</button>*/}
                                                </div>
                                            </Transition>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Is MaherVashin */}
                            {
                                profile.lastName.toLowerCase() === 'joglekar' && profile.gender === 'Female'
                                && (profile.maritalStatus === 'Married' || profile.maritalStatus === 'Divorced' || profile.maritalStatus === 'Widowed') && (
                                    <label className="custom-input-label-checkbox">
                                        <input
                                            type="checkbox"
                                            name='isJoglekarMaherVashin'
                                            checked={isJoglekarMaherVashin}
                                            onChange={() => setIsJoglekarMaheVashin(!isJoglekarMaherVashin)}
                                        />
                                        <p>
                                            {t("REGISTER_PAGE.IS_MAHER_VASHIN")}
                                        </p>
                                    </label>
                                )
                            }

                            {/* Email */}
                            <div className="custom-input-container">
                                <label htmlFor="email">
                                    {t("REGISTER_PAGE.EMAIL_INPUT.LABEL")}
                                </label>

                                <input
                                    disabled={isVerifyEmailOtpSuccess}
                                    type="email"
                                    name="email"
                                    value={profile.email}
                                    onChange={handleFormData}
                                    id="email"
                                    className={`custom-input`}
                                    onBlur={validateEmailId}
                                />

                                {error['email'] && (
                                    <p className="custom-input-error-message" id="email-error">
                                        {error['email']}
                                    </p>
                                )}
                            </div>

                            {/* Email - Send OTP */}
                            <button
                                disabled={isSendEmailOtpButtonDisabled || isVerifyEmailOtpSuccess}
                                onClick={sendOtpOnEmailButtonClick}
                                className={`${!isSendEmailOtpButtonDisabled && 'arrow-button'}
                                    w-full inline-flex items-center justify-center bg-[#D26A53] gap-x-[0.35rem]
                                    landscape:rounded-md portrait:rounded-md portrait:jk:rounded-lg
                                    
                                    portrait:py-[0.5rem] portrait:sm:py-[0.45rem] portrait:jk:py-[0.55rem] portrait:lg:py-[0.75rem]
                                    landscape:py-[0.35rem] landscape:jk:py-[0.4rem] landscape:lg:py-[0.5rem]
                                    
                                    hover:ring-[#5F0F40] hover:ring-offset-1 hover:ring-4 
                                    disabled:cursor-not-allowed disabled:bg-slate-400/50 
                                    disabled:ring-0 disabled:ring-offset-0
                                    transition-all duration-300 ease-in-out`}
                            >
                                <p
                                    className="line-clamp-1 text-white leading-tight font-custom-medium
                                        portrait:text-[1.25rem] portrait:md:text-[1rem]
                                        portrait:jk:text-[1.2rem] portrait:lg:text-[1.5rem]
                                        landscape:text-[0.8rem] landscape:jk:text-[0.9rem] landscape:lg:text-[1rem]"
                                >
                                    {
                                        isVerifyEmailOtpSuccess
                                            ? t("REGISTER_PAGE.OTP_BUTTON.VERIFIED")
                                            : t("REGISTER_PAGE.OTP_BUTTON.SEND")
                                    }
                                </p>
                                {
                                    !isVerifyEmailOtpSuccess && (
                                        <svg
                                            viewBox="0 0 6 6"
                                            fill="none"
                                            id={"arrow-icon"}
                                            className="portrait:h-[1rem] portrait:md:h-[0.9rem]
                                                portrait:jk:h-[1.1rem] portrait:lg:h-[1.4rem]
                                                landscape:h-[0.7rem] landscape:jk:h-[0.8rem] landscape:lg:h-[0.9rem]
                                                aspect-square"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                d="M3 1L5 3L3 5"
                                                id={"arrow-icon-tip"}
                                                stroke="white"
                                                strokeLinecap="square"
                                            />
                                            <path
                                                d="M1 3L4 3"
                                                id={"arrow-icon-line"}
                                                stroke="white"
                                                strokeLinecap="square"
                                            />
                                        </svg>
                                    )
                                }
                            </button>

                            {/* Email - OTP Input | Verify OTP */}
                            {isSendEmailOtpSuccess && (!isVerifyEmailOtpSuccess) && (
                                <>
                                    {/* Email - OTP Input */}
                                    <div className="custom-input-container">
                                        <label
                                            htmlFor="emailOtp"
                                        >
                                            {t("REGISTER_PAGE.OTP_BUTTON.ENTER")}
                                        </label>
                                        <div
                                            className="flex portrait:gap-2 portrait:jk:gap-4 landscape:gap-2"
                                        >
                                            <input
                                                type="text"
                                                name="emailOtp"
                                                value={emailOtp}
                                                onChange={(e) => setEmailOtp(e.target.value)}
                                                id="otp"
                                                className={`custom-input`}
                                            />
                                        </div>
                                    </div>

                                    {/* Email - Verify OTP */}
                                    <button
                                        disabled={isVerifyEmailOtpButtonDisabled}
                                        onClick={verifyEmailOtpButtonClick}
                                        className={`${isVerifyEmailOtpButtonDisabled ? '' : 'arrow-button'} 
                                            w-full inline-flex items-center justify-center bg-[#D26A53] gap-x-[0.35rem]
                                            landscape:rounded-md portrait:rounded-md portrait:jk:rounded-lg
                                            
                                            portrait:py-[0.5rem] portrait:sm:py-[0.45rem] portrait:jk:py-[0.55rem] portrait:lg:py-[0.75rem]
                                            landscape:py-[0.35rem] landscape:jk:py-[0.4rem] landscape:lg:py-[0.5rem]
                                            
                                            hover:ring-[#5F0F40] hover:ring-offset-1 hover:ring-4 
                                            disabled:cursor-not-allowed disabled:bg-slate-400/50 
                                            disabled:ring-0 disabled:ring-offset-0
                                            transition-all duration-300 ease-in-out`}
                                    >
                                        <p
                                            className="line-clamp-1 text-white leading-tight font-custom-medium
                                                portrait:text-[1.25rem] portrait:md:text-[1rem]
                                                portrait:jk:text-[1.2rem] portrait:lg:text-[1.5rem]
                                                landscape:text-[0.8rem] landscape:jk:text-[0.9rem] landscape:lg:text-[1rem]"
                                        >
                                            {t("REGISTER_PAGE.OTP_BUTTON.VERIFY")}
                                        </p>
                                        <svg
                                            viewBox="0 0 6 6"
                                            fill="none"
                                            id={"arrow-icon"}
                                            className="portrait:h-[1rem] portrait:md:h-[0.9rem]
                                                portrait:jk:h-[1.1rem] portrait:lg:h-[1.4rem]
                                                landscape:h-[0.7rem] landscape:jk:h-[0.8rem] landscape:lg:h-[0.9rem]
                                                aspect-square"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                d="M3 1L5 3L3 5"
                                                id={"arrow-icon-tip"}
                                                stroke="white"
                                                strokeLinecap="square"
                                            />
                                            <path
                                                d="M1 3L4 3"
                                                id={"arrow-icon-line"}
                                                stroke="white"
                                                strokeLinecap="square"
                                            />
                                        </svg>
                                    </button>
                                </>
                            )}

                            {/* Phone Number */}
                            <div className="custom-phone-number-input">
                                <label htmlFor="phoneNumber">
                                    {t("LOGIN_PAGE.PHONE_INPUT.LABEL")}
                                </label>
                                <div
                                    className="relative flex-1 flex flex-col
                                            portrait:gap-2 portrait:jk:gap-4 landscape:gap-2"
                                >
                                    {/* Country Code | Phone Number Input */}
                                    <div
                                        className="custom-phone-number-input-container"
                                    >
                                        <button
                                            disabled={isVerifyPhoneNumberOtpSuccess}
                                            onBlur={() => {
                                                if (!isSelectingCountryCode) {
                                                    setIsCountryCodeDropdownOpen(false);
                                                }
                                            }}
                                            onClick={() => setIsCountryCodeDropdownOpen(!isCountryCodeDropdownOpen)}
                                        >
                                            <img
                                                src={`assets/country_flags/${profile.phone.charCode}.png`}
                                                className={"w-[1vw] aspect-auto"}
                                                alt={profile.phone.countryName}
                                            />
                                            <p
                                                className={""}
                                                aria-selected={"false"}
                                            >
                                                {profile.phone.dialingCode}
                                            </p>
                                            <ChevronDownIcon
                                                // onClick={() => setIsCountryCodeDropdownOpen(!isCountryCodeDropdownOpen)}
                                                className={`${isCountryCodeDropdownOpen ? 'rotate-180' : 'rotate-0'} `}
                                                aria-hidden="true"
                                                stroke="#292D32"
                                                strokeWidth={"0.1vh"}
                                            />
                                        </button>
                                        <input
                                            disabled={isVerifyPhoneNumberOtpSuccess}
                                            type="phone"
                                            name="phoneNumber"
                                            className=""
                                            placeholder="7734567890"
                                            value={profile.phone.number || ""}
                                            onChange={(e) => {
                                                setProfile({
                                                    ...profile,
                                                    phone: {
                                                        ...profile.phone,
                                                        number: e.target.value
                                                    }
                                                });

                                                setError({
                                                    ...error,
                                                    [e.target.name]: ""
                                                });
                                            }}
                                            onBlur={validatePhoneNumber}
                                            required
                                        />
                                    </div>

                                    {/* Country Code Dropdown */}
                                    <div className={`relative`}>
                                        <Transition show={isCountryCodeDropdownOpen}>
                                            <div
                                                className={`bg-white absolute left-0 right-0 z-[100] max-h-[15vh]
                                                            origin-top-right rounded-md shadow-2xl 
                                                            border border-gray-700 overflow-y-scroll
                                                            data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 
                                                            data-[enter]:duration-100 data-[enter]:ease-out 
                                                            data-[leave]:duration-75 data-[leave]:ease-in`}
                                            >
                                                {
                                                    countryCodes.map((country, index) => (
                                                        <button
                                                            key={index}
                                                            className="custom-phone-number-input-dropdown-button hover:bg-gray-300"
                                                            onMouseDown={() => setIsSelectingCountryCode(true)}
                                                            onClick={() => handleCountryCodeSelect(country)}
                                                        >
                                                            <img
                                                                // src={`assets/country_flags/${country.countryDialingCode}.png`}
                                                                src={country.countryFlagSrc}
                                                                className={"w-[1vw] aspect-auto"}
                                                                alt={country.countryName}
                                                            />
                                                            <p
                                                                className={"font-custom-regular text-[0.75vw] text-left"}
                                                                aria-selected={"false"}
                                                            >
                                                                {country.countryName}
                                                            </p>
                                                            <p
                                                                className={"font-custom-regular text-[0.75vw]"}
                                                                aria-selected={"false"}
                                                            >
                                                                {'(' + country.countryDialingCode + ')'}
                                                            </p>
                                                        </button>
                                                    ))
                                                }
                                            </div>
                                        </Transition>
                                    </div>
                                </div>

                                {error['phone'] && (
                                    <p
                                        id="email-error"
                                        className="custom-input-error-message"
                                    >
                                        {error['phone']}
                                    </p>
                                )}
                            </div>

                            {/* Phone Number - Send OTP */}
                            <button
                                disabled={isSendPhoneNumberOtpButtonDisabled || isVerifyPhoneNumberOtpSuccess}
                                onClick={sendOtpOnPhoneNumberButtonClick}
                                className={`${!isSendPhoneNumberOtpButtonDisabled && 'arrow-button'}
                                    w-full inline-flex items-center justify-center bg-[#D26A53] gap-x-[0.35rem]
                                    landscape:rounded-md portrait:rounded-md portrait:jk:rounded-lg
                                    
                                    portrait:py-[0.5rem] portrait:sm:py-[0.45rem] portrait:jk:py-[0.55rem] portrait:lg:py-[0.75rem]
                                    landscape:py-[0.35rem] landscape:jk:py-[0.4rem] landscape:lg:py-[0.5rem]
                                    
                                    hover:ring-[#5F0F40] hover:ring-offset-1 hover:ring-4 
                                    disabled:cursor-not-allowed disabled:bg-slate-400/50 
                                    disabled:ring-0 disabled:ring-offset-0
                                    transition-all duration-300 ease-in-out`}
                            >
                                <p
                                    className="line-clamp-1 text-white leading-tight font-custom-medium
                                        portrait:text-[1.25rem] portrait:md:text-[1rem]
                                        portrait:jk:text-[1.2rem] portrait:lg:text-[1.5rem]
                                        landscape:text-[0.8rem] landscape:jk:text-[0.9rem] landscape:lg:text-[1rem]"
                                >
                                    {
                                        isVerifyPhoneNumberOtpSuccess
                                            ? t("REGISTER_PAGE.OTP_BUTTON.VERIFIED")
                                            : t("REGISTER_PAGE.OTP_BUTTON.SEND")
                                    }
                                </p>
                                {
                                    !isVerifyPhoneNumberOtpSuccess && (
                                        <svg
                                            viewBox="0 0 6 6"
                                            fill="none"
                                            id={"arrow-icon"}
                                            className="portrait:h-[1rem] portrait:md:h-[0.9rem]
                                                portrait:jk:h-[1.1rem] portrait:lg:h-[1.4rem]
                                                landscape:h-[0.7rem] landscape:jk:h-[0.8rem] landscape:lg:h-[0.9rem]
                                                aspect-square"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                d="M3 1L5 3L3 5"
                                                id={"arrow-icon-tip"}
                                                stroke="white"
                                                strokeLinecap="square"
                                            />
                                            <path
                                                d="M1 3L4 3"
                                                id={"arrow-icon-line"}
                                                stroke="white"
                                                strokeLinecap="square"
                                            />
                                        </svg>
                                    )
                                }
                            </button>

                            {/* Phone Number - OTP Input | Verify OTP */}
                            {isSendPhoneNumberOtpSuccess && (!isVerifyPhoneNumberOtpSuccess) && (
                                <>
                                    {/* Phone Number - OTP Input */}
                                    <div className="custom-input-container">
                                        <label htmlFor="phoneOtp">
                                            {t("REGISTER_PAGE.OTP_BUTTON.ENTER")}
                                        </label>

                                        <input
                                            type="text"
                                            name="phoneOtp"
                                            value={phoneNumberOtp}
                                            onChange={(e) => setPhoneNumberOtp(e.target.value)}
                                            id="otp"
                                            className={`custom-input`}
                                        />
                                    </div>

                                    {/* Phone Number - Verify OTP */}
                                    <button
                                        disabled={isVerifyPhoneNumberOtpButtonDisabled}
                                        onClick={verifyPhoneNumberOtpButtonClick}
                                        className={`${isVerifyPhoneNumberOtpButtonDisabled ? '' : 'arrow-button'} 
                                            w-full inline-flex items-center justify-center bg-[#D26A53] gap-x-[0.35rem]
                                            landscape:rounded-md portrait:rounded-md portrait:jk:rounded-lg
                                            
                                            portrait:py-[0.5rem] portrait:sm:py-[0.45rem] portrait:jk:py-[0.55rem] portrait:lg:py-[0.75rem]
                                            landscape:py-[0.35rem] landscape:jk:py-[0.4rem] landscape:lg:py-[0.5rem]
                                            
                                            hover:ring-[#5F0F40] hover:ring-offset-1 hover:ring-4 
                                            disabled:cursor-not-allowed disabled:bg-slate-400/50 
                                            disabled:ring-0 disabled:ring-offset-0
                                            transition-all duration-300 ease-in-out`}
                                    >
                                        <p
                                            className="line-clamp-1 text-white leading-tight font-custom-medium
                                                portrait:text-[1.25rem] portrait:md:text-[1rem]
                                                portrait:jk:text-[1.2rem] portrait:lg:text-[1.5rem]
                                                landscape:text-[0.8rem] landscape:jk:text-[0.9rem] landscape:lg:text-[1rem]"
                                        >
                                            {t("REGISTER_PAGE.OTP_BUTTON.VERIFY")}
                                        </p>
                                        <svg
                                            viewBox="0 0 6 6"
                                            fill="none"
                                            id={"arrow-icon"}
                                            className="portrait:h-[1rem] portrait:md:h-[0.9rem]
                                                portrait:jk:h-[1.1rem] portrait:lg:h-[1.4rem]
                                                landscape:h-[0.7rem] landscape:jk:h-[0.8rem] landscape:lg:h-[0.9rem]
                                                aspect-square"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                d="M3 1L5 3L3 5"
                                                id={"arrow-icon-tip"}
                                                stroke="white"
                                                strokeLinecap="square"
                                            />
                                            <path
                                                d="M1 3L4 3"
                                                id={"arrow-icon-line"}
                                                stroke="white"
                                                strokeLinecap="square"
                                            />
                                        </svg>
                                    </button>
                                </>
                            )}
                        </div>

                        {/* Create Account */}
                        <div
                            className="portrait:px-[1.25rem] portrait:pt-[0.25rem] portrait:pb-[0.95rem]
                                portrait:jk:px-[1.5rem] portrait:jk:pt-[0.35rem] portrait:jk:pb-[1.1rem]
                                portrait:lg:px-[2rem] portrait:lg:pt-[0.45rem] portrait:lg:pb-[1.5rem]

                                landscape:px-[1.25rem] landscape:pt-[0.25rem] landscape:pb-[0.95rem]
                                landscape:jk:px-[1.5rem] landscape:jk:pt-[0.35rem] landscape:jk:pb-[1.1rem]
                                landscape:lg:px-[1.75rem] landscape:lg:pt-[0.45rem] landscape:lg:pb-[1.25rem]"
                        >
                            <button
                                disabled={isRegisterButtonDisabled}
                                onClick={addNewAccount}
                                className={`${!(isRegisterButtonDisabled) && 'arrow-button'} 
                                    w-full flex flex-1 items-center justify-center 
                                    gap-x-[0.5rem] bg-[#610329] hover:bg-[#000022] text-white
                                    landscape:rounded-md portrait:rounded-md portrait:jk:rounded-lg
                                    
                                    portrait:py-[0.5rem] portrait:sm:py-[0.45rem] portrait:jk:py-[0.55rem] portrait:lg:py-[0.75rem]
                                    landscape:py-[0.35rem] landscape:jk:py-[0.4rem] landscape:lg:py-[0.5rem]
                                    
                                    disabled:cursor-not-allowed disabled:bg-slate-400/50 
                                    disabled:ring-0 disabled:ring-offset-0
                                    hover:ring-[#5F0F40] hover:ring-offset-1 hover:ring-4
                                    transition-all duration-300 ease-in-out`}
                            >
                                <p
                                    className="line-clamp-1 text-white leading-tight font-custom-medium
                                        portrait:text-[1.25rem] portrait:md:text-[1rem]
                                        portrait:jk:text-[1.2rem] portrait:lg:text-[1.5rem]
                                        landscape:text-[0.75rem] landscape:md:text-[0.8rem]
                                        landscape:jk:text-[0.9rem] landscape:lg:text-[1rem]"
                                >
                                    {t("REGISTER_PAGE.SUBMIT")}
                                </p>
                                <svg
                                    viewBox="0 0 6 6"
                                    fill="none"
                                    id={"arrow-icon"}
                                    className="portrait:h-[1rem] portrait:md:h-[0.9rem]
                                        portrait:jk:h-[1.1rem] portrait:lg:h-[1.4rem]
                                        landscape:h-[0.7rem] landscape:md:h-[0.75rem]
                                        landscape:jk:h-[0.8rem] landscape:lg:h-[0.9rem]
                                        aspect-square"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M3 1L5 3L3 5"
                                        id={"arrow-icon-tip"}
                                        stroke="white"
                                        strokeLinecap="square"
                                    />
                                    <path
                                        d="M1 3L4 3"
                                        id={"arrow-icon-line"}
                                        stroke="white"
                                        strokeLinecap="square"
                                    />
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            {/* Matching Profiles Modal */}
            <Modal zIndex={"z-[100]"} isOpen={showMatchingProfilesModal}>
                <div
                    className={`delete-modal-container`}
                >
                    {/* Header */}
                    <div className={"delete-modal-header-container"}>
                        {/* Family Tree List Modal Header */}
                        <div className={"flex flex-row items-center justify-between"}>
                            {/* Modal Title */}
                            <h2>
                                {t("REGISTER_PAGE.MATCHING_PROFILES_MODAL.TITLE")}
                            </h2>

                            {/* Close Button */}
                            <button
                                onClick={() => setShowMatchingProfilesModal(false)}
                            >
                                <img
                                    className={"w-[75%] h-[75%]"}
                                    src={"/assets/close-icon.png"}
                                    alt={"Close"}
                                    title={"Close"}
                                />
                            </button>
                        </div>

                        {/* Divider */}
                        <div className={"h-[0.2vh] bg-[#ECECEC] rounded-full"}/>
                    </div>

                    {/* Matching Profiles List */}
                    {
                        matchingProfiles.length > 0
                            ? (
                                <div
                                    className="delete-modal-body-container"
                                >
                                    {
                                        matchingProfiles.map((data, index) => (
                                            <button
                                                className={`cursor-pointer
                                                    w-full flex-1 flex items-center gap-x-2 rounded-xl 
                                                    hover:shadow-lg px-[1vh] py-[1vh] border-2 border-[#EAEAEA] bg-white
                                                    transition duration-150 ease-in-out`}
                                                key={index}
                                                // onClick={() => handleNodeClick(data.nodeId)}
                                            >
                                                {/* Profile Picture */}
                                                {data.imageUrl.length <= 2 ? (
                                                    <div
                                                        className={`z-10 w-[8vh] h-[8vh] overflow-hidden 
                                                                flex items-center justify-center rounded-lg 
                                                                shadow-xl border-2 border-[#F5F5F5] ${data.imageUrlBg}`}
                                                    >
                                                        <p
                                                            className={
                                                                "text-[1vw] text-white font-custom-mono-bold"
                                                            }
                                                        >
                                                            {data.imageUrl.toUpperCase()}
                                                        </p>
                                                    </div>
                                                ) : (
                                                    <div
                                                        className="z-10 w-[8vh] h-[8vh] overflow-hidden flex items-center justify-center rounded-lg bg-slate-500 border-2 border-white">
                                                        <img
                                                            src={
                                                                !(data.imageUrl === "")
                                                                    ? data.imageUrl
                                                                    : "/assets/default-pfp.png"
                                                            }
                                                            referrerPolicy={"no-referrer"}
                                                            alt="Member Profile Picture"
                                                        />
                                                    </div>
                                                )}

                                                {/* Firstname | Middlename | Family Tree Name */}
                                                <div
                                                    className="h-full flex-1 flex flex-col items-start justify-between">
                                                    <p className="text-[1.75vh] font-custom-medium text-[#3D3D3D] leading-snug">
                                                        {data.firstName + " " + data.middleName}
                                                    </p>
                                                    <p className="text-[1.5vh] font-custom-medium text-[#3D3D3D] leading-snug">
                                                        {data.firstNameDevanagariScript +
                                                            " " +
                                                            data.middleNameDevanagariScript}
                                                    </p>
                                                    <div className="py-[0.25vh] px-[0.5vw] bg-[#F3BC50] rounded-full">
                                                        <p className="text-[1.25vh] font-custom-medium text-[#3D3D3D] leading-snug">
                                                            {data.familyTreeName}
                                                        </p>
                                                    </div>
                                                </div>
                                            </button>
                                        ))
                                    }
                                </div>
                            )
                            : (
                                <div
                                    className="delete-modal-body-container"
                                >
                                    <p className={"text-[1.5vw] font-custom-mono-medium text-wrap text-center"}>
                                        {t(`REGISTER_PAGE.MATCHING_PROFILES_MODAL.NO_MATCHING_PROFILES`)}
                                    </p>
                                </div>
                            )
                    }
                </div>
            </Modal>
        </>
    )
}
